import { observer } from 'mobx-react-lite';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelFormType } from '@mark43/cad-api';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../panels/entity-panels/tabs/tab-subtitle';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { Box } from '@cad-arc';
import { EventPanelFormPersonsFields } from '../../event-panel-form/involved-person-vehicle-fields/persons/event-panel-form-persons-fields';

export const PersonsTab = observer(function PersonsTab() {
    const eventForm = useFormContext<EventPanelFormType>();
    const reportingParties = useWatch({
        control: eventForm.control,
        name: 'reportingParties',
    });
    const involvedPersons = useWatch({
        control: eventForm.control,
        name: 'involvedPersons',
    });
    const mergedInvolvedPersons = useWatch({
        control: eventForm.control,
        name: 'mergedInvolvedPersons',
    });
    const mergedReportingParties = useWatch({
        control: eventForm.control,
        name: 'mergedReportingParties',
    });

    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const eventPanelConfig = useBootstrapState().eventPanelConfiguration;

    return (
        <EventPanelTab title="Persons">
            <TabBody>
                <TabSubtitle>Reporting Parties ({reportingParties.length})</TabSubtitle>
                <FormBody>
                    <>
                        <EventPanelFormPersonsFields
                            form={eventForm}
                            displayAsCards={true}
                            noMembersText="No Reporting Parties"
                            allowMembersControl={true}
                            baseKey="reportingParties"
                            addButtonText="Add Reporting Party"
                            eventPanelOptions={eventPanelOptions!}
                            eventPanelConfig={eventPanelConfig}
                        />

                        <Box pt={4}>
                            <TabSubtitle>Involved Persons ({involvedPersons.length})</TabSubtitle>
                            <EventPanelFormPersonsFields
                                form={eventForm}
                                displayAsCards={true}
                                noMembersText="No Involved Persons"
                                allowMembersControl={true}
                                baseKey="involvedPersons"
                                addButtonText="Add Involved Person"
                                eventPanelOptions={eventPanelOptions!}
                                eventPanelConfig={eventPanelConfig}
                            />
                        </Box>

                        {eventMetadata?.hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Reporting Parties ({mergedReportingParties.length})
                                </TabSubtitle>
                                <EventPanelFormPersonsFields
                                    form={eventForm}
                                    displayAsCards={true}
                                    noMembersText="No Merged Reporting Parties"
                                    allowMembersControl={false}
                                    baseKey="mergedReportingParties"
                                    eventPanelOptions={eventPanelOptions!}
                                    eventPanelConfig={eventPanelConfig}
                                />
                            </Box>
                        )}

                        {eventMetadata?.hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Involved Persons ({mergedInvolvedPersons.length})
                                </TabSubtitle>
                                <EventPanelFormPersonsFields
                                    form={eventForm}
                                    displayAsCards={true}
                                    noMembersText="No Merged Involved Persons"
                                    allowMembersControl={false}
                                    baseKey="mergedInvolvedPersons"
                                    eventPanelOptions={eventPanelOptions!}
                                    eventPanelConfig={eventPanelConfig}
                                />
                            </Box>
                        )}
                    </>
                </FormBody>
            </TabBody>
        </EventPanelTab>
    );
});
